let AltHeader = function () {

    this.header = $('#standard-header-wrap');
    this.altHeader = $('#alternate-header-wrap');

    this.navbar = $('#navbar');
    this.navToggle = $('#mobileNavToggle');

    this.init();
};

/**
 * Add event listeners
 */
AltHeader.prototype.init = function () {
    $(document).on('click', 'button[data-action="show-header"]', function () {
        this.showStandard();
    }.bind(this));
};

AltHeader.prototype.showStandard = function () {

    this.altHeader.hide();

    this.header.css('opacity', 0)
        .slideDown('200')
        .animate({
                opacity: 1,
                display: 'block'
            },
            {
                queue: false,
                duration: 'slow',
                complete: function () {
                    if (this.navToggle.attr("aria-expanded") === 'false' && this.navbar.css('display') === 'none') {
                        this.navbar.collapse('show');
                    }
                }.bind(this)
            }
        );
};

/**
 * Static initialiser
 */
AltHeader.init = function () {
    return new AltHeader();
};

export default AltHeader;